<script>
import baseList from "@/views/components/base/baseList.vue";
import { Tag, Button } from "view-design";
import Vue from "vue";
import Info from "../info.vue";
import Repair from "../repair.vue";
import EditPro from "../editProcessing.vue";
import Track from "../track.vue";
export default {
  extends: baseList,
  components: {
    info: Info,
    Repair,
    Track,
    EditPro,
  },
  data() {
    return {
      menu_name: "",
      makeMain:"",
      table: {
        mname: "work",
        key: "id",
        url: {
          list:"/customer/customer/workOrder/selectList"
        },
        output: false,
        order: "repairTime",
      },
      actions: [
        // {
        //   label: '新增',
        //   icon: 'md-add',
        //   onClick: this.toAdd,
        //   auth: '',
        // },
        // {
        //   label: '导入',
        //   icon: 'md-add',
        //   onClick: this.toImport,
        //   auth: '',
        // },
        // {
        //   label: '下载模板',
        //   icon: '',
        //   onClick: this.toDownload,
        //   auth: '',
        // },
      ],
      menus: [
        {
          label: "待处理",
          name: "workOrder_await_cus",
          auth: "system/workOrder/index",
          badge: { mname: "workstate", scene: "1",url:"/customer/customer/workOrder/state" },
        },
        {
          label: "处理中",
          name: "workOrder_processing_cus",
          auth: "system/processing/index",
          badge: { mname: "workstate", scene: "2",url:"/customer/customer/workOrder/state" },
        },
        {
          label: "已完成",
          name: "workOrder_completed_cus",
          auth: "system/completed/index",
        },
      ],
      query: {
        state: 2,
      },
      filters: [
        {
          label: "报修时间",
          KeyEnter: this.search,
          name: "repairTime",
          value: "",
          type: "datetimerange",
        },
        {
          label: "工单类型",
          name: "typeName",
          value: "",
          KeyEnter: this.search,
          type: "select",
          dropList: [],
        },
        {
          label: "资产名称",
          name: "facilityName",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "问题描述",
          KeyEnter: this.search,
          name: "descr",
          value: "",
          type: "input",
        },
        {
          label: "科室",
          name: "department",
          value: "",
          KeyEnter: this.search,
          type: "input",
        },
        {
          label: "资产编号",
          KeyEnter: this.search,
          name: "facilityNum",
          value: "",
          type: "input",
        },
      ],
      tableCols: [
        {
          title: "序号",
          type: "index",
          width: 80,
          align: "center",
        },
        {
          title: "问题描述",
          key: "descr",
          width: 120,
          align: "left",
          render: (h, params) => {
            const row = params.row;
            const text = row.descr;
            let tempDescr;
            let teColor
            if (text != null) {
              let arr = text.split(']')
              let tempDate = parseInt(arr[0])
              if (tempDate < 30 ) {
                tempDescr = '[' + '0h' + tempDate + 'm]'+arr[1]
                teColor = "green"
              } else if ((tempDate > 30 && tempDate < 60)|| tempDate == 30) {
                teColor = "red"
                tempDescr = '[' + '0h' + tempDate + 'm]'+arr[1]
              } else
              if (tempDate > 60 || tempDate == 60) {
                teColor = "red"
                let hour = Math.floor(tempDate / 60)
                let min = tempDate % 60
                tempDescr = '[' + hour + 'h' + min + 'm]'+arr[1]
              }

            }
            return h('div', [
              h('span', {
                style: {
                  display: 'inline-block',
                  width: '100%',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  color:teColor,
                },
                domProps: {
                  title: tempDescr
                }
              }, tempDescr)
            ])
          },
        },
        {
          title: "报修时间",
          minWidth: 150,
          align: "center",
          key: "repairTime",
          sortable: true,
          render: (h, params) => {
            const row = params.row;
            const text = row.repairTime.slice(0, 16);
            return <span>{text}</span>;
          },
        },
        // {
        //
        //   title: "所在科室",
        //   key: "department",
        //   minWidth: 100,
        //   align: "center",
        //   tooltip: "true",
        // },
        // {
        //   title: "具体位置",
        //   key: "address",
        //   minWidth: 120,
        //   align: "center",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text = row.address === null ? row.facilitySite : row.address;
        //     return <span style={{ "font-size": "14px" }}>{text}</span>;
        //   },
        // },
        {
          title: "工单类型",
          key: "typeName",
          minWidth: 120,
          align: "left",
          tooltip: "true",
        },
        // {
        //   title: "协同工单",
        //   key: "isSynergy",
        //   minWidth: 100,
        //   align: "center",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text = row.isSynergy === 0 ? "否" : "是";
        //     return <span style={{ "font-size": "14px" }}>{text}</span>;
        //   },
        // },
        {
          title: "处理人",
          key: "maintainerName",
          minWidth: 120,
          align: "left",
        },
        {
          title: "处理人电话",
          key: "phone",
          minWidth: 120,
          align: "left",
          tooltip: "true",
        },
        {
          title: "状态",
          key: "sendId",
          minWidth: 100,
          align: "center",
          render: (h, params) => {
            const row = params.row;
            const text = row.sendId === null ? "处理中" : "送修中";
            return <span style={{ "font-size": "14px" }}>{text}</span>;
          },
        },
        // {
        //   title: "报修来源",
        //   key: "repairSource",
        //   minWidth: 110,
        //   align: "center",
        //   render: (h, params) => {
        //     const row = params.row;
        //     const text =
        //       row.repairSource === 1 && row.isFastOrder === 0
        //         ? "扫码报修"
        //         : row.repairSource === 1 && row.isFastOrder === 1
        //         ? "移动报修"
        //         : row.repairSource === 3 &&
        //           row.callId !== null &&
        //           row.isFastOrder === 1
        //         ? "电话报修"
        //         : row.repairSource === 3 && row.isFastOrder === 0
        //         ? "后台设备报修"
        //         : row.repairSource === 3 && row.isFastOrder === 1
        //         ? "后台科室报修"
        //         : row.repairSource === 2
        //         ? "维修员"
        //         : "";
        //     return <span style={{ "font-size": "14px" }}>{text}</span>;
        //   },
        // },
        {
          title: "操作",
          align: "center",
          width: 190,
          key: "handle",
          fixed: "right",
          handle: [
            (vm, h, currentRow, param) => {
              // let directives = []
              return (
                <Button
                  size="small"
                  onClick={() => this.toInfo(currentRow)}
                  type="default"
                  style={{
                    border:"none",
                    color: "#4991ff",
                    marginTop: "2px",
                    marginRight: "5px",
                  }}
                >
                  详情
                </Button>
              );
            },
          ],
        },
      ],
    };
  },

  created() {
    this.loadLevelDatas();
    this.loaddeskData();
    // this.loadFiltersFieldDrop('community', 'community_id')
  },
  methods: {
    async deskChange(query) {
      if (query !== "") {
        setTimeout(async () => {
          let q = {
            deskName: query,
          };

          let res = await $utils.api
            .load(`/customer/customer/desk/list`, q, "get")
              const list = res.rows.map((item) => {
                return {
                  value: item.id,
                  name: item.deskName,
                };
              });
              // let dropList = list.filter(item => item.label.toLowerCase().indexOf(query.toLowerCase()) > -1);

              for (let index = 0; index < this.filters.length; index++) {
                const element = this.filters[index];
                if (element && element.name == "deskId") {
                  this.filters[index]["dropList"] = list;
                }
              }
        }, 200);
      } else {
        this.dropList = [];
      }
    },
    async loaddeskData() {
      // 通过pk查询字典数据
      let q = {};
      // q.state = 2;
      let res = await $utils.api
        .load(`/customer/customer/desk/list`, q)
          if (res && res.rows) {
            let ll = res.rows;
            let dropList = [];
            for (let index = 0; index < ll.length; index++) {
              const element = ll[index];
              let xx = {};
              xx.value = element.id;
              xx.name = element.deskName;
              xx.children = element.children || [];
              dropList.push(xx);
            }
            for (let index = 0; index < this.filters.length; index++) {
              const element = this.filters[index];
              if (element && element.name == "deskId") {
                this.filters[index]["dropList"] = (
                  element["dropList"] || []
                ).concat(dropList);
              }
            }
          }
    },
    async loadLevelDatas() {
      // 通过pk查询字典数据
      let q = {};
      // q.state=1
      let res = await $utils.api.load("/customer/customer/workType/list", q)
        if (res && res.rows) {
          let ll = res.rows;
          let dropList = [];
          for (let index = 0; index < ll.length; index++) {
            const element = ll[index];
            let xx = {};
            xx.value = element.name;
            xx.name = element.name;
            xx.children = element.children || [];
            dropList.push(xx);
          }
          for (let index = 0; index < this.filters.length; index++) {
            const element = this.filters[index];
            if (element && element.name == "typeName") {
              this.filters[index]["dropList"] = (
                element["dropList"] || []
              ).concat(dropList);
            }
          }
        }
    },
    toInfo(row) {
      $utils.url.push({
        name: "workOrder_info_cus",
        query: { action: "edit", kv: row.id, workId: row.id },
      });
    },
  },
};
</script>
<style scoped></style>
